import { CSSProperties } from 'react';

export const levelCardStyle: CSSProperties = {
  marginTop: 12,
  borderRadius: 12,
  overflow: 'hidden',
  border: '1px solid #e2e8f0',
};

export const levelCardHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flex: 1,
};

export const levelCardCodeStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 36,
  height: 28,
  padding: '0 8px',
  borderRadius: 8,
  backgroundColor: '#eff6ff',
  color: '#1e6df6',
  fontWeight: 600,
  fontSize: 13,
  border: 'none',
  margin: 0,
  lineHeight: 1,
};

export const levelCardTitleStyle: CSSProperties = {
  fontWeight: 500,
  color: '#191c1f',
};

export const levelCardDefinitionStyle: CSSProperties = {
  color: '#94a3b8',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1.4,
  maxWidth: 320,
  whiteSpace: 'normal',
};

export const levelCardExamplesStyle: CSSProperties = {
  color: '#64748b',
  fontSize: 11,
  fontWeight: 400,
  fontStyle: 'italic',
  lineHeight: 1.4,
  maxWidth: 320,
  whiteSpace: 'normal',
  marginTop: 2,
};

export const levelCardPricingCountStyle: CSSProperties = {
  marginLeft: 'auto',
  color: '#94a3b8',
  fontSize: 13,
  flexShrink: 0,
};

export const levelCardBodyStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
};

export const levelCardFieldsStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
  flexWrap: 'wrap',
};

export const levelCardFieldItemStyle: CSSProperties = {
  flex: 1,
  minWidth: 200,
};

export const levelCardOptionalStyle: CSSProperties = {
  marginLeft: 8,
  color: '#94a3b8',
  fontWeight: 400,
  fontSize: 13,
};

export const levelCardClockSectionStyle: CSSProperties = {
  marginTop: 4,
};

export const levelCardClockHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 12,
};

export const levelCardSharedBadgeStyle: CSSProperties = {
  backgroundColor: '#ecfdf5',
  color: '#059669',
  border: '1px solid #a7f3d0',
  borderRadius: 999,
  fontSize: 12,
  padding: '2px 10px',
  margin: 0,
};
